import React from 'react';
import Title from '../../Common/Title';
import { useTranslation } from 'react-i18next';
import InvoiceTable from '../../Common/InvoiceTable';
import { tableColumns } from '../../../Utils/facture.util';
import { FactureContainerType } from '../../../Types/facture.type';
import useLandingStore from '../../../Store/Landing';
import { StyledBox } from '../../../Theme/CommonStyled';

const FactureDetailsTable: React.FC<{
  tableData: FactureContainerType[];
  finalPrice: number;
}> = ({ tableData, finalPrice }) => {
  const { t } = useTranslation();

  const landingData = useLandingStore((state) => state.landingData);

  return (
    <>
      <Title title={t('facture.factureDetails')} mb={8} />
      <StyledBox flexDirection="column" mb="0 !important">
        <InvoiceTable
          columns={tableColumns(landingData?.currency)}
          tableData={tableData}
          costSum={String(finalPrice)}
        />
      </StyledBox>
    </>
  );
};

export default FactureDetailsTable;
